module.exports = __webpack_public_path__ + "img/c05_unittechcretanbowmanchampion_Normal_ua.c8f63bfe.webp";